import React from 'react';

import { TabOptions } from 'components/common/CustomFilters/DateRangeFilter/DateRangeFilter.utils';

import { TabItem, Tabs } from 'components/DesignSystem/Tabs';

import classes from './Header.module.scss';

interface IHeaderProps {
    activeTab: TabOptions;
    setActiveTab: React.Dispatch<React.SetStateAction<TabOptions>>;
}

export const Header = ({ activeTab, setActiveTab }: IHeaderProps) => {
    return (
        <div className={classes.headerContainer}>
            <Tabs tabs={tabs} value={activeTab} onChange={(value) => setActiveTab(value as TabOptions)} />
        </div>
    );
};

const tabs: TabItem[] = [
    { value: 'FIXED_DATE', label: 'Fixed Date' },
    { value: 'TODAY_REF', label: "Today's Reference" },
    {
        value: 'VERSION_DATE_REF',
        label: 'Version Date Reference',
    },
];
